import React, { HTMLAttributes, ReactNode } from 'react';
import styled from '@emotion/styled';
import { ITheme, Paper } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useNewBookingStore } from '../../../domain/booking/stores/useNewBookingsStore';
import { BookingDate } from '../../booking/BookingDate';
import { BookingQr } from '../../booking/BookingQr';
import { getDaysInTotalDetails } from '../../../domain/utils/getDaysInTotalDetails';
import { ITranslationFunction } from '../../../../shared/i18n/translate';
import themed from '../../../../../ui/themer/themed';

export const ConfirmationBookingDetails = () => {
	const { t } = useTranslation();
	const { booking } = useNewBookingStore();
	const productName = booking.parkingProduct?.name;
	const { daysInTotal } = booking;

	if (!booking.isSubmitted) {
		return null;
	}

	return (
		<Wrap>
			{booking.reference && <StyledBookingQr reference={booking.reference} />}
			{productName && (
				<ProductNameRow
					name={t('parking_booking_product_name')}
					value={
						<ProductNameValue
							name={productName}
							daysInTotal={daysInTotal}
							translation={t}
						/>
					}
				/>
			)}
			{booking.entryDate && (
				<Row
					name={t('parking_booking_entry_date')}
					value={
						<BookingDate
							date={booking.entryDate}
							selectedTime={booking.entryTime}
						/>
					}
				/>
			)}
			{booking.exitDate && (
				<Row
					name={t('parking_booking_exit_date')}
					value={
						<BookingDate
							date={booking.exitDate}
							selectedTime={booking.exitTime}
						/>
					}
				/>
			)}
		</Wrap>
	);
};
interface IProductNameValueProps {
	name: string;
	daysInTotal?: number;
	translation: ITranslationFunction;
}
const ProductNameValue = ({
	name,
	daysInTotal,
	translation,
}: IProductNameValueProps) => (
	<div>
		{name}
		{daysInTotal && (
			<div>{getDaysInTotalDetails(daysInTotal, translation)}</div>
		)}
	</div>
);
const Wrap = styled(Paper)`
	padding: 0;
`;

interface IRowProps extends HTMLAttributes<HTMLDivElement> {
	name: string;
	value?: ReactNode;
	childrem?: ReactNode;
}

const StyledRow = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 16px;
`;

const Row = ({ name, value, ...rest }: IRowProps) => (
	<StyledRow {...rest}>
		<Name>{name}</Name>
		<Value>{value ?? '-'}</Value>
	</StyledRow>
);

const Name = styled.div`
	margin-right: 16px;
`;

const Value = styled.div`
	font-weight: 700;
	text-align: right;
	flex-basis: 60%;
	flex-shrink: 0;
`;

const ProductNameRow = styled(Row)<{}, ITheme>`
	background: ${themed(({ background }) => background.light)};
`;

const StyledBookingQr = styled(BookingQr)`
	padding: 40px;

	canvas {
		display: block;
		margin: 0 auto;
	}
`;
